// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3eEMS","colCheckbox":"styles_colCheckbox__3tVEN"};